import React from 'react'
import { Col, Container, Image, Row } from 'react-bootstrap'
import britecoImg from '../../../../../Assets/nokaoi-imges/briteco-logo.webp'
import { useHistory } from 'react-router-dom/cjs/react-router-dom';

const Briteco = () => {
  const history = useHistory();
  return (
    <div className='no_briteco_section'>
      <Container>
        <Row>
            <Col sm={12} md={12} lg={12}>
            <div className='no_briteco_box'>
<Image src={britecoImg} alt="no_briteco" loading="lazy" className='img-fluid'/>
<p>Insuring your purchase with BriteCo is faster, easier, and more affordable than ever before</p>
            </div>
            <button className='bri_btn_read_more' onClick={()=>history.push('/briteco')}>Read More</button>
            </Col>
        </Row>
      </Container>
    </div>
  )
}

export default Briteco
